import axios from 'axios';

export default axios.create({
  baseURL: '//directions.rewn.io/route/v1/driving/',
  timeout: 0,
  headers: {'Content-Type': 'application/json'},
});

// export default axios.create({
//   baseURL: 'http://127.0.0.1:5000',
//   timeout: 1000,
//   headers: {'Content-Type': 'application/json'},
// });
